<template>
  <div class="login-container">
    <div class="login-card">
      <div class="text-center mb-4">
        <NvLogo style="height: 80px" />
        <h2 class="mt-3">Azure DevOps Toolkit</h2>
        <p class="text-muted">Sign in with your Microsoft account to access this page</p>
      </div>

      <div class="text-center">
        <b-button
          variant="primary"
          size="lg"
          @click="signIn"
          :disabled="isLoading"
          class="login-button"
        >
          <b-spinner v-if="isLoading" small class="me-2" />
          <b-icon-microsoft v-else class="me-2" />
          Sign in
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import NvLogo from '@/components/UI/NvLogo.vue';
import { mapStores } from 'pinia';
import useApiStore from '@/stores/api';
import useAuthStore from '../stores/checkAuth';

export default {
  name: 'LoginPage',
  components: {
    NvLogo,
  },
  data() {
    return {
      isLoading: false,
      error: null,
    };
  },
  async created() {
    this.isLoading = true;
    const isAuthenticated = await this.authStore.checkAuthStatus();

    if (isAuthenticated) {
      const token = await this.authStore.getAccessToken();
      if (token) {
        this.redirectAfterLogin();
      }
    }
    this.isLoading = false;
  },
  computed: {
    ...mapStores(useApiStore),
    ...mapStores(useAuthStore),
  },
  methods: {
    async signIn() {
      this.isLoading = true;

      try {
        const isAuthenticated = await this.authStore.checkAuthStatus();
        if (isAuthenticated) {
          this.redirectAfterLogin();
          return;
        }

        const loginSuccess = await this.authStore.login();

        if (loginSuccess) {
          toast('Successfully signed in!', {
            type: 'success',
            position: 'bottom-center',
            theme: 'light',
            autoClose: 2000,
          });

          this.redirectAfterLogin();
        }
      } catch (error) {
        console.error('Login error:', error);

        toast('Sign in failed. Please try again.', {
          type: 'error',
          position: 'bottom-center',
          theme: 'light',
          autoClose: 10000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    redirectAfterLogin() {
      const redirectPath = this.$route.query.redirect || '/release-note-generator';
      this.$router.push(redirectPath);
    },
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  background: white;
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: 1rem;
}

.login-button {
  width: 90%;
  font-weight: 600;
}

h2 {
  font-weight: 700;
}
</style>
